import VideoCard from '@/components/feature/VideoCard';
import { getHotVideos } from '@/mocks/videos';

export default function HotRanking() {
  const hotVideos = getHotVideos();

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                热门排行
              </h2>
              <p className="text-foreground-500 text-sm">本周最受欢迎的视频内容，大家都在看</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {hotVideos.map((video, index) => (
              <div key={video.id} className="relative">
                {index < 3 && (
                  <div className="absolute top-3 left-3 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {index + 1}
                  </div>
                )}
                <VideoCard video={video} variant="compact" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}